module.exports = __webpack_public_path__ + "img/3.1a9d6d52.png";